<template>
  <li class="nav-item">
    <router-link
      :to="link.path"
      @click="linkClick"
      :class="[isActive ? 'active nav-link' : 'nav-link']"
      :target="link.target"
      :href="link.path"
    >
      <template>
        <i :class="link.icon"></i>
        <span class="nav-link-text text-nowrap">{{ link.name }}</span>
        <div
          v-if="
            ((link.name == 'Find employees' || link.name == 'Find Jobs') &&
              hasJobBriefingNotification) ||
            (link.name == 'Trade Partners' && hasProjectNotification) ||
            (link.name == 'Find employees' && hasJobApplicationNotification)
          "
          style="float: right; position: relative; top: -5px"
        >
          <svg
            width="13"
            height="12"
            viewBox="0 0 13 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="6.97656"
              cy="6"
              r="5"
              fill="#FA0000"
              stroke="white"
              stroke-width="2"
            />
          </svg>
        </div>
      </template>
    </router-link>
  </li>
</template>
<script>
import { hasProjectNotification as hasProjectNotificationHelper } from '@/utils/notifications'
export default {
  name: "sidebar-item",
  props: {
    link: {
      type: Object,
      default: () => {
        return {
          name: "",
          path: "",
          children: [],
        }
      },
      description:
        "Sidebar link. Can contain name, path, icon and other attributes. See examples for more info",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  computed: {
    isActive() {
      return this.$route.fullPath.indexOf(this.link.path.split("/")[1]) > -1
    },
    hasJobBriefingNotification() {
      const profile = this.$store.state.userProfile
      if (!profile) return false

      return (
        profile.type === "jobSeeker" &&
        profile.profilesRequested?.findIndex(
          (x) => x.type === "job" && x.profile !== profile._id
        ) > -1
      )
    },
    hasJobApplicationNotification() {
      const profile = this.$store.state.userProfile
      if (!profile) return false

      return (
        profile.type === "provider" &&
        profile.profilesRequested?.findIndex((x) => x.type === "job-application") > -1
      )
    },
    hasProjectNotification() {
      const projects = this.$store.state.projects?.list || [];
      const profilesRequested = this.$store.state.userProfile?.profilesRequested || [];
      return hasProjectNotificationHelper(projects, profilesRequested);
    },
  },
  data() {
    return {
      children: [],
      collapsed: true,
    }
  },
  methods: {
    async linkClick() {
      await this.$store.dispatch("api/getUserProfile", {
        userId: this.$store.state.user._id,
      })
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false)
      }
    },
  },
}
</script>
